"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const MyDonationStatsBox_1 = __importDefault(require("./MyDonationStatsBox"));
const store_1 = require("../../store/store");
const MyDonationStats = ({ donorData }) => {
    const { appSettings } = (0, store_1.useAppSelector)((state) => state.app);
    const { hideUnitPrefixInDonationStats } = appSettings || {};
    const boxes = _.map(donorData === null || donorData === void 0 ? void 0 : donorData.donationStats, (box, key) => {
        const { color, icon, amount, unit, description } = box;
        return box.show ? ((0, jsx_runtime_1.jsx)(MyDonationStatsBox_1.default, { showUnit: !hideUnitPrefixInDonationStats, color: color, icon: icon, amount: amount, unit: unit, description: description }, key)) : null;
    });
    const showAtleastOne = donorData === null || donorData === void 0 ? void 0 : donorData.donationStats.some(({ show }) => show);
    return showAtleastOne ? ((0, jsx_runtime_1.jsxs)("div", { className: "my-donation-stats", children: [(0, jsx_runtime_1.jsx)("h5", { children: __.trans('donation.my-blood-donation') }), (0, jsx_runtime_1.jsx)("div", { className: "box-row", children: boxes })] })) : null;
};
exports.default = MyDonationStats;
